import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {addEditMedicalSpeciality, delMedicalSpeciality, getMedicalSpecialities} from '../../services';
import {IMedicalSpeciality, IMedicalSpecialityFilter, IMedicalSpecialityRes, IMedicalSpecialityState} from "../types/IMedicalSpeciality";
import historyHelper from "../../helpers/history";
import {AppState} from "./rootReducer";

const initialState: IMedicalSpecialityState = {
    status: "idle"
}

export const mostrarMedicalSpecialities = createAsyncThunk(
    'mostrarMedicalSpecialities', async (params:IMedicalSpecialityFilter|undefined, thunkAPI ) => {
        const {medicalSpecialities} = thunkAPI.getState() as AppState;
        let paramsFilter = params || medicalSpecialities.filtered;

        const response = await getMedicalSpecialities(paramsFilter)
        return {data: response.data as IMedicalSpecialityRes, params: response.config.params}
    }
)

export const agregarEditarMedicalSpeciality = createAsyncThunk(
    'MedicalSpecialities/agregarEditar', async (medicalSpeciality: IMedicalSpeciality) => {
        const response = await addEditMedicalSpeciality(medicalSpeciality);
        if (response.status === 200 || response.status === 204) historyHelper.back();
        return {data: response.data, edit:!!medicalSpeciality.id};
    }
);

export const eliminarMedicalSpeciality = createAsyncThunk(
    'medicalSpeciality/eliminar', async (id: number) => {
        await delMedicalSpeciality(id);
        // if (response.status === 200 || response.status === 204) historyHelper.back();
        return id;
    }
);


const slice = createSlice({
    name: 'mostrarMedicalSpecialities',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarMedicalSpecialities
        builder.addCase(mostrarMedicalSpecialities.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarMedicalSpecialities.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarMedicalSpecialities.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarEditarMedicalSpeciality
        builder.addCase(agregarEditarMedicalSpeciality.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarMedicalSpeciality.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
                if(!action.payload.edit){
                    ++state.list.pageSize
                    ++state.list.totalCount
                }

            }
        })
        builder.addCase(agregarEditarMedicalSpeciality.rejected, (state ) => {
            state.status = "idle";
        })
        //--eliminarMedicalSpeciality
        builder.addCase(eliminarMedicalSpeciality.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarMedicalSpeciality.fulfilled, (state,action ) => {
            state.status = "idle";
            const id = action.payload;
            if(state.list?.items){
                state.list.items = state.list?.items.filter(e => e.id !== id)
            }
        })
        builder.addCase(eliminarMedicalSpeciality.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export default slice.reducer;
